const NAMESPACE = "calculatedField";

const KEYS = {
    configurationErrorMessage: "configurationErrorMessage",
    errorPrefix: "errorPrefix",
    hideDetailsMessage: "hideDetailsMessage",
    showDetailsMessage: "showDetailsMessage",
    defaultResultValueText: "defaultResultValueText"
};

const MESSAGES = {
    [KEYS.configurationErrorMessage]: {
        value:
            "Error: This form element has not been configured properly. " +
            "A user with the Edit Forms privilege can repair this by navigating to the " +
            "Field Properties of this Calculated Field element and selecting a Calculated Field.",
        comment: "Message about improper field configuration, along with information on how to fix the error."
    },
    [KEYS.errorPrefix]: {
        value: "Error: ",
        comment: "Prefix for error message in calculating field data."
    },
    [KEYS.hideDetailsMessage]: {
        value: "Hide Details",
        comment: "Button to hide result details"
    },
    [KEYS.showDetailsMessage]: {
        value: "Show Details",
        comment: "Button to show result details"
    },
    [KEYS.defaultResultValueText]: {
        value: "{Result}",
        comment: "Placeholder text for calculated field value when configuring element."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
